import classNames from 'classnames';
import styles from './Spinner.module.scss';

export const Cypress_DATA = {
  spinner: 'base-spinner',
};

interface SpinnerProps {
  size?: number | string;
  centered?: boolean;
  className?: string;
  dataCy?: string;
  text?: string;
}

export const Spinner = ({
  size = 40,
  centered = false,
  dataCy,
  className = '',
  text,
}: SpinnerProps) => {
  const hasText = Boolean(text);
  const spinnerDimensions = { width: size, height: size };
  const wrapperStyle = hasText ? undefined : spinnerDimensions;

  return (
    <div
      className={classNames(styles.wrapper, className, {
        [styles.centered]: centered,
        [styles.withText]: hasText,
      })}
      style={wrapperStyle}
      data-cy={dataCy ?? Cypress_DATA.spinner}
    >
      <svg
        className={styles.spinner}
        viewBox="0 0 50 50"
        style={spinnerDimensions}
      >
        <circle
          className={styles.path}
          cx="25"
          cy="25"
          r="20"
          fill="none"
          stroke="currentColor"
          strokeWidth="5"
        />
      </svg>
      {hasText && <p className={styles.text}>{text}</p>}
    </div>
  );
};
